import { render, staticRenderFns } from "./DataViewer.vue?vue&type=template&id=b407772c&scoped=true&"
import script from "./DataViewer.vue?vue&type=script&lang=js&"
export * from "./DataViewer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b407772c",
  null
  
)

export default component.exports